import React, { useEffect, useState } from "react";
import { Card, CardContent } from "../../components/ui/card";

import CustomButton from "../../components/customButton";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getAllpackages } from "../../lib/apis";
import Loader from "../../components/loader";
import { useTranslation } from "react-i18next";
import { scrollToTop } from "../../lib/utils";

const SelectProd = () => {
  const token = localStorage.getItem("token");
  // console.log(token)
  const navigate = useNavigate();
  const [packages, setPackages] = useState([])
  const { t } = useTranslation()
  const [loader, setLoader] = useState(true)
  const updatePackage = async () => {
    try {
      const { data } = await axios.get(getAllpackages,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
      setPackages(data.data)
      console.log("package", data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoader(false)
    }
  }

  useEffect(() => {
    scrollToTop()
  }, [])

  useEffect(() => {
    updatePackage()
    // eslint-disable-next-line
  }, [])
  return (
    <div className="w-full  bg-gray-100 p-8 flex flex-col items-center">
      <div className="text-center text-3xl font-semibold mb-6">
        {t("prix_marche")}
      </div>

      <div style={{ flexWrap: "wrap" }} className="flex justify-center gap-3 w-full">
        {loader ? <Loader /> :
          packages.map((item: any) => {
            const descriptions = JSON.parse(item.package_description)
            const typeDescription = typeof descriptions
            console.log(descriptions.length)
            console.log(typeof descriptions)
            return (
              <Card className="w-[400px]">
                <CardContent className="p-5 w-full">
                  <div className="flex flex-col py-8">
                    <div className=" text-2xl text-center mb-4">
                      {item.package_name}
                    </div>

                    <div style={{ fontWeight: "bold" }}>{t("nombre_produit")} {item.number_of_product}</div>
                  </div>

                  {/* vendeur */}
                  {/* <Accordion type="single" collapsible>
                    <AccordionItem value="item-1">
                      <AccordionTrigger className="w-full"> */}
                  {
                    typeDescription === "object" && descriptions.map((description: any) => {
                      return (
                        <>
                          <div className="flex justify-between items-center">
                            <div className="flex gap-8 items-center">
                              <div className="flex flex-col gap-1 text-[15px] font-normal items-start ">
                                <span>{description}</span>
                              </div>
                            </div>
                            {/* <div className="h-[24px] w-[24px] rounded-full border-black border-solid border-[1px] flex justify-center items-center">
                              <img
                                className="h-[13px] w-[13px]"
                                src="/chevronDown.svg"
                                alt=""
                              />
                            </div> */}
                          </div>
                          <div className="h-[1px] w-full bg-primary my-3"></div>
                        </>

                      )
                    })
                  }

                  {/* </AccordionTrigger>
                      <AccordionContent></AccordionContent>
                    </AccordionItem>
                  </Accordion> */}








                  <div className="flex justify-center py-5">
                    <CustomButton
                      rounded
                      className="bg-primary text-white px-4 py-2"
                      onClick={() => navigate(`/souscriptions_duree/${item.package_id}`, { state: item })}
                    >
                      <span className="text-[11px]">{t("consulter_durer")}</span>
                    </CustomButton>
                  </div>
                </CardContent>
              </Card>
            )
          })
        }
      </div>
    </div>
  );
};

export default SelectProd;
